export default{
  namespaced: true,
  state:{
    reservations: []
  },
  getters : {},
  mutations:{
    ADD_RESERVATION_TO_LIST(state,data){
      state.reservations = data
    }
  }
}